import {ResolverService} from '../services/resolver.service';
import {TranslateService} from '@ngx-translate/core';
import {ErrorService} from '../services/error.service';
import {AuthService} from '../../auth/auth.service';
import {environment} from '../../../environments/environment';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {isNullOrUndefined} from 'util';
import {Page} from '../services/HttpServiceBase';
import {Brand, Category, CategoryStructure, ProductStructure, Rarity} from './entities';
import {BrandService} from '../../services/brand.service';
import {CategoryService} from '../../services/category.service';
import {ProductStructureService} from '../../services/product-structure.service';
import {CategoryStructureService} from '../../services/category-structure.service';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {RarityService} from '../../services/rarity.service';
import {HoloService} from '../../services/holo.service';

/**
 * Created by Klayer3
 */
export class ComponentBase {

  private structureSubject: Subject<ProductStructure> = new Subject<ProductStructure>();
  public readonly productStructureChange: Observable<ProductStructure> = this.structureSubject.asObservable();
  public readonly categoryStructureService: CategoryStructureService = ResolverService.instance().getService('CategoryStructureService');

  public readonly constants = environment.constants;

  public readonly cardTypes = environment.constants.cardTypes;

  public readonly defaultLanguageId = environment.constants.defaultLanguageId;

  public readonly cardLanguages = environment.constants.cardLanguages;

  public readonly sessionTypes = environment.constants.sessionTypes;
  public readonly sessionTypesList = [this.sessionTypes.CARICO, this.sessionTypes.TRASFERIMENTO, this.sessionTypes.SCARICO];

  public readonly sessionStates = environment.constants.sessionStates;
  public readonly sessionStatesList= [this.sessionStates.OPEN, this.sessionStates.WAITING_APP, this.sessionStates.APPROVED,  this.sessionStates.COMPLETE];

  public readonly orderStates = environment.constants.orderStates;
  public readonly marketOrderStates = environment.constants.marketOrderStates;
  public readonly orderStatesList= Object.keys(environment.constants.orderStates).map(k => this.orderStates[k]);
  public readonly marketOrderStatesList= Object.keys(environment.constants.marketOrderStates).map(k => this.marketOrderStates[k]).filter(s => s != this.marketOrderStates.LOST  && s != this.marketOrderStates.CANCELLED);

  protected readonly _translateService: TranslateService = ResolverService.instance().tranlateService;

  protected readonly errorService: ErrorService = ResolverService.instance().getService('ErrorService');

  public readonly authService: AuthService = ResolverService.instance().getService('AuthService');

  public readonly brandService: BrandService = ResolverService.instance().getService('BrandService');
  public readonly rarityService: RarityService = ResolverService.instance().getService('RarityService');
  public readonly holoService: HoloService = ResolverService.instance().getService('HoloService');
  public readonly categoryService: CategoryService = ResolverService.instance().getService('CategoryService');
  public readonly productStructureService: ProductStructureService = ResolverService.instance().getService('ProductStructureService');


  public readonly productStructureFields = [...environment.constants.cardTypes, 'rarity', 'edition', 'expansion', 'holo', 'language', 'condition'];

  private $rarities: Rarity[] = [];
  private $categoryStructure: CategoryStructure;
  private $currentProductStruct: ProductStructure;
  private $categoryId: number;
  private $brandId: number;

  get rarities(): Rarity[] {
    return this.$rarities;
  }

  get brandId(): number{
    return this.$brandId || this.getStorage('currentBrand', false);
  }

  set brandId(brand: number){
    this.$brandId = brand;
    this.saveStorage('currentBrand', brand, false);
    this.loadCurrentStruct();
  }

  get categoryId(): number{
    return this.$categoryId || this.getStorage('currentCategory', false);
  }

  set categoryId(category: number){
    this.$categoryId = category;
    this.saveStorage('currentCategory', category, false);
    this.$rarities = this.rarityService.getData().filter( r => r.brandId == this.brandId);
    this.loadCurrentStruct();
  }


  avaibleBrands: number[] = [];

  private loadCurrentStruct() {


    let brandId = 0;
    const categoryId = this.categoryId;
    this.avaibleBrands = [];
    if ( categoryId) {

      if ( this.brandId) brandId = this.brandId;
      let found: CategoryStructure[] = this.categoryStructureService.data.filter( cs => cs.categoryId == categoryId );
      this.avaibleBrands = found.map( cs => cs.brandId);
      if ( found.length > 1 ){
        const brandFound =  found.filter( cs => cs.brandId == brandId) || found.filter( cs => cs.brandId == 0);
        if ( brandFound.length == 1){
          found = brandFound;
        }
      }


      if ( found.length > 0 ){
        const catStruct: CategoryStructure = found[0];
        this.productStructureService.loadById(catStruct.productStructureId, false).subscribe( ps => {
           this.$brandId = catStruct.brandId;
          this.saveStorage('currentBrand', catStruct.brandId);
          this.$rarities = this.rarityService.getData().filter( r => r.brandId == this.brandId);
          this.currentProductStruct  = ps;
          }
        );
        return ;
      }
    }

    this.currentProductStruct = null;


  }

  get currentProductStruct(): ProductStructure{
    return this.$currentProductStruct ;
  }

  set currentProductStruct(productStructure: ProductStructure){
    this.$currentProductStruct = productStructure;
    this.saveStorage('currentProductStruct', productStructure, false);
    this.structureSubject.next(productStructure);
  }

  isEnabledStructure(field: string){
    return this.productStructureFields.findIndex( s => s == field) == -1 || ( this.$currentProductStruct && this.$currentProductStruct.allFields && this.$currentProductStruct.allFields.find( s => s === field));
  }

  protected clear(obj: any){
    if ( obj ){
      this.productStructureFields.forEach( f => {
        if ( !this.isEnabledStructure(f)) {
            obj[f] = undefined;
        }
      });
    }
  }

  public compareEntity(o: any, o2: any) {
    if ( isNullOrUndefined(o) && isNullOrUndefined(o2) ) {
      return true;
    }

    if ((isNullOrUndefined(o) && !isNullOrUndefined(o2)) || (isNullOrUndefined(o2) && !isNullOrUndefined(o))) {
      return false;
    }

    return o === o2 || o.id === o2.id;
  }



  toJson(obj ) {
    console.log('ComponentBase.toJson', obj);
    return obj ? JSON.stringify(obj) : null;
  }

  get translate() {
    return this._translateService;
  }

  a_translate(key: string | Array<string>, interpolateParams?: Object) {
    return this._translateService.get(key, interpolateParams);
  }

  get spinnerService(): Ng4LoadingSpinnerService{
    return ResolverService.instance().spinnerService;
  }


  isNull(laqlq){
    return isNullOrUndefined(laqlq);
  }

  isNullOrEmpty(laqlq){
    return  isNullOrUndefined(laqlq) || 'null' == '' + laqlq || 'undefined' == '' + laqlq || '' == '' + laqlq;
  }

  getName(){
    return (<any>this).constructor.name;
  }


  constructor() {
    console.log(this.getName());
    this.categoryStructureService.dataChange.subscribe( () => {
      this.$brandId = this.getStorage('currentBrand', false);
      this.categoryId = this.getStorage('currentCategory', false);
    });

  }

  saveStorage(key: string, value: any, usePrefix: boolean = true){
    if ( value){
      if (key == 'page'){
        value = Object.assign({}, value);
        value['content'] = [];
        //value['url'] = undefined;
      }
      localStorage.setItem(usePrefix ? this.getName() + '.' + key : key , JSON.stringify(value));
    } else
      this.removeStorage(key, usePrefix);
  }

  removeStorage(key: string,  usePrefix: boolean = true){
    localStorage.removeItem(usePrefix ? this.getName() + '.' + key : key);
  }

  getStorage(key: string,  usePrefix: boolean = true){
    const item =  JSON.parse(localStorage.getItem(usePrefix ? this.getName() + '.' + key : key));
    if ( item ){
       if (key == 'page'){
         item['content'] = [];
         //item['url'] = undefined;
       }
    }
    return item;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/entities/component-base.ts